export const playList = ['0tRc6vHQvQo','POA0gEJNh1Q','3zLhPuwHseA','NVBn3Zw08Cg','0tRc6vHQvQo'];
export const weiIndex = ['guojia', 'caiwenji', 'xiahouchun'];
export const wuIndex = ['sunshangxiang', 'zhouyu', 'ganning'];
export const shuIndex = ['zhugeliang', 'guanyu', 'machao'];
export const qunIndex = ['lvbu', 'diaochan', 'dongzhuo'];
export const wei = {
    guojia: {
        charDesc:
            '字奉孝，潁川陽翟人，初為東漢末年群雄袁紹麾下，後成為曹操麾下重要謀士，任司空府軍師祭酒，封洧陽亭侯，諡號貞侯。',
        skillName: '横征暴敛',
        skillDesc:
            '◆ 我方造成暴击伤害或者成功格挡敌方伤害时，降低敌方2%的攻击，最多叠加至50%，直至本场战斗结束',
    },
    caiwenji: {
        charDesc:
            '東漢大文豪蔡邕之女，被匈奴所虜，居胡地十二年，曹操敬佩蔡邕文采，遂將文姬贖回，史稱“文姬歸漢”。',
        skillName: '悲音斷腸',
        skillDesc:
            '◆ 戰前準備回合開始，我方在「音」、「律」、「曲」、「調」4種效果中隨機選擇2種發動',
    },
    xiahouchun: {
        charDesc:
            '字元讓，曹魏名將，少年時以勇氣聞名鄉里，多次為曹操鎮守後方，功勳卓著，官至大將軍。',
        skillName: '忠勇剛烈',
        skillDesc:
            '◆ 我方前軍受到敵方造成的傷害後，有50%的概率將該傷害的25%反彈給敵方',
    },
};
export const wu = {
    sunshangxiang: {
        charDesc:
            '孫權之妹，自幼喜好武藝，為桀驁不馴的剛強女子，人稱“弓腰姬”，為鞏固孫劉聯盟嫁於劉備，後回歸東吳。',
        skillName: '江東梟姬',
        skillDesc: '◆ 我方弓兵部隊受到所有負面效果的概率降低50',
    },
    zhouyu: {
        charDesc:
            '字公瑾，人稱“周郎”，廬江舒縣人，東漢末年孫權陣營重要的統帥，也是傑出優秀的軍事家、戰術家、戰略家、政治家。與魯肅、呂蒙和陸遜合稱四大都督。',
        skillName: '西臨洮人',
        skillDesc:
            '◆ 我方前軍受到敵方造成的傷害後，有50%的概率將該傷害的25%反彈給敵方我方前軍受到敵方造成的傷害後，有50%的概率將該傷害的25%反彈給敵方',
    },
    ganning: {
        charDesc:
            '字興霸，益州巴郡臨江人，是東漢末年三國時期東吳的著名將領，曾經歷仕於劉表和黃祖麾下不被重用，轉投孫權麾下受到周瑜、呂蒙的推舉。協助魯肅與呂蒙對峙關羽；是江東十二虎臣之一。',
        skillName: '涼州隴',
        skillDesc:
            '◆ 我方前軍受到敵方造成的傷害後，有50%的概率將該傷害的25%反彈給敵方我方前軍受到敵方造成的傷害後，有50%的概率將該傷害的25%反彈給敵方',
    },
};
export const shu = {
    zhugeliang: {
        charDesc:
            '字孔明，東漢末年徐州琅琊陽都人。三國蜀漢丞相，著名的政治家、軍事家、發明家和散文家。隱居隆中，自比管仲、樂毅，人稱“臥龍”。',
        skillName: '横征暴敛',
        skillDesc:
            '◆ 我方造成暴击伤害或者成功格挡敌方伤害时，降低敌方2%的攻击，最多叠加至50%，直至本场战斗结束',
    },
    guanyu: {
        charDesc:
            '字雲長，本字長生，司隸河東解良人，約生於東漢桓帝延熹年間，漢末三國時劉備的主要親信和將領，與趙雲、張飛、馬超、黃忠並稱“五虎上將”。',
        skillName: '閉月羞花',
        skillDesc:
            '◆ 我方部隊受到敵方造成的英雄技能傷害降低15%，並將所降低的傷害進行累計（傷害累計值不超過自身最大兵力上限的30%），在下一場戰鬥的戰前準備回合開始，全額返還給下一支上場的敵方部隊',
    },
    machao: {
        charDesc:
            '字孟起，扶風茂陵人，漢末三國時期蜀漢著名將領。劉備稱帝后任驃騎將軍，領涼州牧，進封斄鄉侯，與關羽、張飛、黃忠、趙雲並稱“五虎上將”。',
        skillName: '西臨洮人',
        skillDesc:
            '◆ 我击伤害或方造成暴击伤害或方造成暴击伤害或方击伤害或方造成暴击伤害或方造成暴击伤害或方',
    },
};
export const qun = {
    diaochan: {
        charDesc:
            '四大美人之一，王允義女，有傾國之貌，以美色周旋於董卓，呂布之間，成功離間二人，使呂布董卓反目。',
        skillName: '閉月羞花',
        skillDesc:
            '◆ 我方部隊受到敵方造成的英雄技能傷害降低15%，累計所降低的傷害，並在下一場戰鬥開始前全額返還給敵方部隊，若敵方部隊英雄為男性，則返還傷害翻倍',
    },
    dongzhuo: {
        charDesc:
            '董卓，字仲穎，涼州隴西臨洮人，東漢與羌的戰爭中崛起的漢軍將領。董卓長期參與漢羌戰爭，先後跟過張奐、段熲兩位漢軍高級將領。',
        skillName: '閉月羞花',
        skillDesc:
            '◆ 我方部隊受到敵方造成的英雄技能傷害降低15%,並將所降低的傷害進行累計（傷害累計值不超過自身最大兵力上限的30%）',
    },
    lvbu: {
        charDesc:
            '呂布，字奉先，并州五原郡九原人，東漢末年著名武將與軍閥。先後為丁原、董卓的部將，也曾為袁紹效力，後乘劉備與袁術交戰時而佔據徐州，自成一方勢力。',
        skillName: '閉月羞花',
        skillDesc:
            '◆ 我方部隊受到敵方造成的英雄技能傷害降低15%,並將所降低的傷害進行累計（傷害累計值不超過自身最大兵力上限的30%）',
    },
};
